import React, { useEffect, useState } from "react";
import { Calendar } from "lucide-react";

const StickyBookCTA = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="/contact"
      className={`fixed right-5 bottom-24 md:bottom-5 z-30 bg-knight-gold hover:bg-knight-gold/90 text-knight-navy font-bold px-5 py-3 rounded-full shadow-2xl flex items-center gap-2 transition-all duration-300 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"}`}
      style={{ boxShadow: "0 12px 32px -4px rgba(244, 180, 0, 0.55)" }}
    >
      <Calendar size={18} />
      <span className="hidden sm:inline">Book Free Consultation</span>
      <span className="sm:hidden">Book</span>
    </a>
  );
};

export default StickyBookCTA;
